import React, { useRef } from 'react';
import { Button, ButtonProps } from 'primereact/button';

import './tnk-button.scss';

type TnkButtonMode = 'primary' | 'secondary' | 'danger' | 'text' | 'custom';

interface TnkButtonProps extends ButtonProps {
  buttonType?: TnkButtonMode;
  fullWidth?: boolean;
}

const MODE_CLASS: Record<TnkButtonMode, string> = {
  primary: 'tnk-button-primary',
  secondary: 'tnk-button-secondary',
  danger: 'tnk-button-danger',
  text: 'tnk-button-text',
  custom: '',
};

const TnkButton: React.FC<TnkButtonProps> = ({
  buttonType: mode = 'primary',
  fullWidth = false,
  className,
  onClick,
  ...props
}) => {
  const pendingRef = useRef(false);

  const cls = ['tnk-button', MODE_CLASS[mode], fullWidth ? 'tnk-button-full-width' : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!onClick || pendingRef.current) return;
    const result: unknown = onClick(e);
    // Auto-lock button while async handler is pending to prevent duplicate API calls
    if (result instanceof Promise) {
      pendingRef.current = true;
      result.finally(() => {
        pendingRef.current = false;
      });
    }
  };

  return <Button className={cls} onClick={handleClick} {...props} />;
};

export default TnkButton;
